// extracted by mini-css-extract-plugin
export var link = "_w4-0";